import axios from 'axios';
import { XMLParser } from 'fast-xml-parser';
import Head from 'next/head';
export default function Home({ data }) {
  return (
    <main className='sitemap'>
      <Head>
        <title>Sitemap - 24hrdoc</title>
        <meta
          name='description'
          content='Explore the 24hrdoc sitemap for quick access to online treatments, prescription services, and informational resources.'
        />
        <link rel='canonical' href='https://www.24hrdoc.com/sitemap' />
        <meta
          property='og:image'
          content={
            'https://www.24hrdoc.com/_next/image?url=%2Fassets%2Ficons%2FLogoTransparent.png&w=256&q=75'
          }
        />
      </Head>
      <div className='container'>
        <h1 className=' tw-my-6 tw-text-3xl'>
          <span className='gradientText'>24hrdoc Sitemap</span>
        </h1>
        <div className='row heading'>General</div>
        <div className='row pagesContainer'>
          {data.GeneralPage.map((i) => (
            <a className='col-md-4' href={i.link} key={i.link}>
              {i.title}
            </a>
          ))}
        </div>
        {/* <div className='row heading'>Service</div>
        <div className='row pagesContainer'>
          {data.ServicePage.map((i) => (
            <a className='col-md-4' href={i.link} key={i.link}>
              {i.title}
            </a>
          ))}
        </div> */}

        {data.CategoryPage.map((i) => (
          <>
            <div className='row heading'>{i.category}</div>
            <div className='row pagesContainer'>
              {i.service.map((k) => (
                <a className='col-md-4' href={k.link} key={k.link}>
                  {k.title}
                </a>
              ))}
            </div>
          </>
        ))}

        <div className='row heading'>Blogs</div>
        <div className='row pagesContainer'>
          {data.BlogPage.map((i) => (
            <a className='col-md-4' href={i.link} key={i.link}>
              {i.title}
            </a>
          ))}
        </div>
      </div>
      {/* <BottomImage path={'/services'} /> */}
    </main>
  );
}

export async function getStaticProps({ params }) {
  const { data } = await axios.get('https://24hrdoc.com/sitemap.xml');
  const parser = new XMLParser();
  const parsed = parser.parse(data);

  const GeneralPage = [];
  const BlogPage = [];
  const ServicePage = [];
  const CategoryPage = [];

  for (let index = 0; index < parsed.urlset.url.length; index++) {
    const element = parsed.urlset.url[index];

    const split = element.loc.split('/');

    if (split.length === 3) {
      GeneralPage.push({ link: element.loc, title: 'Home Page' });
      continue;
    }

    if (split.length === 4) {
      const title = split[3].split('-').join(' ');
      GeneralPage.push({ link: element.loc, title: title });
      continue;
    }

    if (split.includes('diagnosis')) {
      continue;
    }
    if (split.includes('eligibility')) {
      continue;
    }
    // if (split.includes('weight-loss')) {
    //   continue;
    // }
    if (split.includes('blog')) {
      const title = split[4].split('-').join(' ');
      BlogPage.push({ link: element.loc, title: title });
      continue;
    }
    if (split.includes('services')) {
      const title = split[5].split('-').join(' ');
      ServicePage.push({ link: element.loc, title: title });
      continue;
    }

    if (split.length === 5) {
      const category = split[3].split('-').join(' ');
      const title = split[4].split('-').join(' ');

      const categoryIndex = CategoryPage.findIndex(
        (o) => o.category === category
      );

      if (categoryIndex === -1) {
        CategoryPage.push({
          category: category,
          service: [{ link: element.loc, title: title }],
        });
        continue;
      }

      CategoryPage[categoryIndex].service.push({
        link: element.loc,
        title: title,
      });
      continue;
    }

    // return (
    //   <li className='col-md-6' key={i.loc}>
    //     <a href={i.loc}>{i.loc}</a>
    //   </li>
    // );
  }

  return {
    revalidate: 3600,
    props: {
      data: {
        GeneralPage: GeneralPage,
        BlogPage: BlogPage,
        ServicePage: ServicePage,
        CategoryPage: CategoryPage,
      },
    },
  };
}
